


 const Header= ()=> {
  return (
    <div>
      {/* <img className = "headerImg" src="https://thumbs.dreamstime.com/b/street-food-vintage-rusty-metal-sign-white-background-vector-illustration-street-food-vintage-rusty-metal-sign-224573958.jpg" alt="" /> */}

    </div>
  )
}
export default Header